import TermsModal from './TermsModal';
import TermsModalContainer from './TermsModalContainer';

export {TermsModalContainer};
export default TermsModal;
